import { getCookie, removeCookie, setCookie } from "./cookies";

export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "chaveToken";
export const USER_ID_KEY = "idUsuario";

export const SESSION_KEYS = [
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_ID_KEY,
] as const;

const SESSION_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

const readLocal = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const removeLocal = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch {
    return;
  }
};

const writeLocal = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    return;
  }
};

const readValue = (key: string): string => {
  const value = getCookie(key) ?? readLocal(key);

  return value?.trim() || "";
};

const clearValue = (key: string) => {
  removeCookie(key);
  removeLocal(key);
};

const writeValue = (key: string, value?: string | null) => {
  const normalized = typeof value === "string" ? value.trim() : "";

  if (!normalized) {
    clearValue(key);
    return;
  }

  const stored = setCookie(key, normalized, {
    maxAgeSeconds: SESSION_MAX_AGE_SECONDS,
  });

  if (stored) {
    removeLocal(key);
    return;
  }

  writeLocal(key, normalized);
};

export const getAccessToken = () => readValue(ACCESS_TOKEN_KEY);

export const setAccessToken = (token?: string | null) =>
  writeValue(ACCESS_TOKEN_KEY, token);

export const getRefreshToken = () => readValue(REFRESH_TOKEN_KEY);

export const setRefreshToken = (token?: string | null) =>
  writeValue(REFRESH_TOKEN_KEY, token);

export const getUserId = () => readValue(USER_ID_KEY);

export const setUserId = (id?: string | number | null) =>
  writeValue(USER_ID_KEY, id === null || id === undefined ? "" : String(id));

export const hasActiveSession = () => Boolean(getAccessToken());

export const clearSession = () => {
  SESSION_KEYS.forEach(clearValue);

  try {
    localStorage.clear();
  } catch {
    return;
  }
};
